import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import axios from 'axios';

export default function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('loading'); // loading, success, or error
  const [message, setMessage] = useState('Verifying your email...');
  const [countdown, setCountdown] = useState(5);
  const navigate = useNavigate();

  useEffect(() => {
    const token = searchParams.get('token');

    if (!token) {
      setStatus('error');
      setMessage('No verification token found. Please check your email link.');
      return;
    }

    // Call your backend API
    axios.get(`/api/verify-email?token=${token}`)
      .then((res) => {
        setStatus('success');
        setMessage(res.data.message || 'Email verified successfully!');
      })
      .catch((err) => {
        setStatus('error');
        setMessage(err.response?.data?.message || 'Verification failed or token expired.');
      });
  }, [searchParams]);

  // Handle countdown redirect on success
  useEffect(() => {
    if (status === 'success' && countdown > 0) {
      const timer = setTimeout(() => setCountdown(countdown - 1), 1000);
      return () => clearTimeout(timer);
    } else if (status === 'success' && countdown === 0) {
      navigate('/login');
    }
  }, [status, countdown, navigate]);

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] px-4 text-center">
      <div className="max-w-md w-full bg-white p-8 rounded-xl shadow-lg border border-gray-100">
        
        {/* Loading State */}
        {status === 'loading' && (
          <div className="animate-pulse">
            <div className="h-12 w-12 bg-blue-100 rounded-full mx-auto mb-4 flex items-center justify-center text-blue-600">
              <i data-feather="loader"></i>
            </div>
            <h2 className="text-2xl font-bold text-gray-800 mb-2">Verifying...</h2>
            <p className="text-gray-600">Please wait while we confirm your account.</p>
          </div>
        )}

        {/* Success State */}
        {status === 'success' && (
          <div>
            <div className="h-16 w-16 bg-green-100 rounded-full mx-auto mb-4 flex items-center justify-center text-green-600">
               <span className="text-3xl">✓</span>
            </div>
            <h2 className="text-2xl font-bold text-gray-800 mb-2">Success!</h2>
            <p className="text-gray-600 mb-6">{message}</p>
            <p className="text-sm text-gray-500 mb-4 italic">
              Redirecting to login in {countdown} seconds...
            </p>
            <Link to="/login" className="block w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 transition">
              Go to Login Now
            </Link>
          </div>
        )}

        {/* Error State */}
        {status === 'error' && (
          <div>
            <div className="h-16 w-16 bg-red-100 rounded-full mx-auto mb-4 flex items-center justify-center text-red-600">
               <span className="text-3xl">✕</span>
            </div>
            <h2 className="text-2xl font-bold text-gray-800 mb-2">Verification Failed</h2>
            <p className="text-gray-600 mb-6">{message}</p>
            <div className="space-y-3">
               <Link to="/register" className="block w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 transition">
                  Try Registering Again
               </Link>
               <Link to="/" className="block text-blue-600 hover:underline text-sm font-medium">
                  Return to Home
               </Link>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
